import { Button, Sheet, VStack } from '@hover/blueprint';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { useDeleteClickHandler } from 'src/modules/homeownerApp/hooks/useDeleteClickHandler';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks/useHomeownerAppContext';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';

const MoreActions = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { activeAiOriginalImage, setCurrentMenu } = useHomeownerAppContext();
  const history = useHistory();

  const [handleDeleteClick, deleteResult] = useDeleteClickHandler(
    activeAiOriginalImage?.id,
  );

  useEffect(() => {
    if (deleteResult.data || deleteResult.error) {
      setCurrentMenu(undefined);
      history.push(Routes.HOMEOWNER_APP_HOME.path);
    }
  }, [deleteResult.data, deleteResult.error, history, setCurrentMenu]);

  return (
    <Sheet.Contents>
      <VStack paddingY={400} width="100%">
        <Button variant="primary" width="100%">
          {t('uploadedImage.replacePhoto')}
        </Button>
        <Button
          isLoading={deleteResult.loading}
          onClick={handleDeleteClick}
          variant="ghost"
          width="100%"
        >
          {t('uploadedImage.delete')}
        </Button>
      </VStack>
    </Sheet.Contents>
  );
};

export { MoreActions };
